<template>
  <div class="recycler-table">
    <div class="recycler-header recycler-flex">
      <span
        v-for="(header, idx) in headers"
        :key="`${idx}${header.value}`"
        :ref="header.value"
        :class="idx == 0 ? 'fixed-col cell' : 'cell'"
      >
        <span @click="onClickHandler(header)">
          {{ header.key }}
          <v-icon
            v-if="header.sortable"
            small
            :color="activeSort === header.value ? '#fff' : '#60677E'"
          >
            {{
              sort[header.value] === "asc" ? "arrow_upward" : "arrow_downward"
            }}</v-icon
          >
        </span>
      </span>
    </div>
    <RecycleScroller
      class="scroller"
      :items="recycleData"
      :key-field="key_field"
      :item-size="40"
      :buffer="100"
    >
      <template slot="default" slot-scope="{ item, index }">
        <span
          v-for="(header, idx) in headers"
          :key="`${index}${idx}${header.value}`"
          :class="
            idx == 0
              ? 'fixed-col cell'
              : item[header.value] == null
              ? 'error--text cell'
              : 'number--text cell'
          "
        >
          {{
            header.value.includes("Breaker Status") ||
            header.value.includes("SPD Status")
              ? item[header.value] == null
                ? "NA"
                : item[header.value]
              : item[header.value] != null
              ? item[header.value]
              : "null"
          }}
        </span>
      </template>
    </RecycleScroller>
  </div>
</template>

<script>
import _ from "lodash";
import { miscellaneous } from "@/util/mixin/index.js";

export default {
  mixins: [miscellaneous],
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      },
      required: true,
    },
    headers: {
      type: Array,
      default: function () {
        return [];
      },
      required: true,
    },
    key_field: {
      type: String,
      required: true,
    },
    tableHeight: {
      type: String,
      default: "688px",
    },
    slotWise: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recycleData: [],
      activeSort: "",
      sort: {},
    };
  },
  mounted() {
    this.recycleData = _.cloneDeep(this.items);
    document.querySelector(".scroller").style.height = this.tableHeight;
    this.initialSort();
    if (this.recycleData.length === 0) {
      const newItem = {};
      this.headers.forEach((el) => {
        newItem[el.value] = "No Data";
      });
      this.recycleData.push(newItem);
    }

    this.$el
      .querySelector(".recycler-header")
      .addEventListener(
        "scroll",
        this.scrollHandler.bind(this, "vue-recycle-scroller")
      );

    this.$el
      .querySelector(".vue-recycle-scroller")
      .addEventListener(
        "scroll",
        this.scrollHandler.bind(this, "recycler-header")
      );
  },
  destroyed() {
    this.$el
      .querySelector(".recycler-header")
      .removeEventListener(
        "scroll",
        this.scrollHandler.bind(this, "vue-recycle-scroller")
      );
    this.$el
      .querySelector(".vue-recycle-scroller")
      .removeEventListener(
        "scroll",
        this.scrollHandler.bind(this, "recycler-header")
      );
  },
  methods: {
    onClickHandler(header) {
      if (header.sortable) {
        this.sortStateHandler(header.value);
        this.recycleData = this.arraySortHandler(
          this.recycleData,
          header.value,
          this.sort[header.value],
          this.slotWise
        );
      }
    },
    initialSort() {
      const sortObj = {};
      // Always takes one parameter to sort by
      const initialSortParam = this.headers.filter((el) => el.initialSortBy);
      let sortByParam = "";
      if (initialSortParam.length) {
        sortByParam = initialSortParam[0].value;
      } else {
        sortByParam = this.headers[0].value;
      }
      this.headers.forEach((header, index) => {
        if (!header.sortable) {
          return;
        }
        if (header.value === sortByParam) {
          sortObj[header.value] = "asc";
          this.activeSort = header.value;
          this.recycleData = this.arraySortHandler(
            this.recycleData,
            header.value,
            this.sort[header.value],
            this.slotWise
          );
        } else {
          sortObj[header.value] = "desc";
        }
      });
      this.sort = sortObj;
    },
    sortStateHandler(param) {
      this.activeSort = param;
      Object.keys(this.sort).forEach((el) => {
        if (el !== param) {
          this.sort[el] = "desc";
        } else {
          if (this.sort[param] === "asc") {
            this.sort[param] = "desc";
          } else {
            this.sort[param] = "asc";
          }
        }
      });
    },
    scrollHandler(className, event) {
      const elm = this.$el.querySelector(`.${className}`);
      elm.scrollLeft = event.target.scrollLeft;
    },
  },
  watch: {
    items() {
      this.recycleData = _.cloneDeep(this.items);
      this.initialSort();
      if (this.recycleData.length === 0) {
        const newItem = {};
        this.headers.forEach((el) => {
          newItem[el.value] = "No Data";
        });
        this.recycleData.push(newItem);
      }
      this.$el.querySelector(".vue-recycle-scroller").scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.recycler-table {
  display: grid;
}

.recycler-header {
  overflow-x: scroll;
  height: 55px;
  max-height: 55px;
  font-size: 12px;
}

.recycler-row {
  border-bottom: 1px solid gray;
}

.cell {
  width: 200px;
  padding: 10px;
  text-align: center;
  min-width: 200px;
}

.fixed-col {
  background-color: var(--v-primary-base);
  position: sticky;
  left: 0;
}
.recycler-flex {
  display: flex;
}
</style>

<style>
.theme--dark .vue-recycle-scroller__item-view {
  display: flex;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.12);
}

.theme--light .vue-recycle-scroller__item-view {
  display: flex;
  border-bottom: 1px solid black;
}

.vue-recycle-scroller__item-wrapper {
  overflow: visible;
}

.vue-recycle-scroller.ready.direction-vertical
  .vue-recycle-scroller__item-view {
  width: auto;
}
</style>
